// Single source of truth for site content. `null` = renders a visible admin placeholder.
export const SITE = {
  name: "Schwimmschule Manta",
  url: "https://schwimmschulemanta.de/",
  email: "info@schwimmschulemanta.de",
  phone: null,
  parentAppUrl: "https://app.schwimmschulemanta.de/login",
  bookingUrl: "https://widgets.yolawo.de/w/6a942a8177b69f85cea4d4bc",
  impressumUrl: "/impressum",
  datenschutzUrl: "/datenschutzerklrung",
  agbUrl: "/agb",
  adultBookingUrl: "https://widgets.yolawo.de/w/6aabccc2792c12f3b5ea720d",
  privateBookingUrl: "https://widgets.yolawo.de/w/0/offers/6a9d770efa69059fe85a95bc",
  region: "Darmstadt, Dieburg & Umgebung",
};

export const mailto = (subject) =>
  `mailto:${SITE.email}?subject=${encodeURIComponent(subject)}`;

export const bookingHref = (course) =>
  course?.bookingUrl ?? SITE.bookingUrl ?? mailto(course ? `Kursanfrage: ${course.name}` : "Kursanfrage");

export const NAV = [
  { id: "start", label: "Startseite" },
  { id: "kurse", label: "Schwimmkurse" },
  { id: "erwachsene", label: "Erwachsene" },
  { id: "privatstunden", label: "Privatstunden" },
  { id: "konzept", label: "Unser Konzept" },
  { id: "ueber-uns", label: "Über uns" },
  { id: "faq", label: "Häufige Fragen" },
  { id: "kontakt", label: "Kontakt" },
];

export const COURSES = [
  {
    slug: "frosch",
    level: "01",
    name: "Froschkurs",
    kicker: "Wassergewöhnung",
    age: "Ab 3,5 Jahren",
    image: "/images/pair.webp",
    alt: "Zwei Kinder mit Schwimmbrillen am Beckenrand eines Hallenbads",
    text: "Der erste Schritt: spielerisch Vertrauen ins Wasser fassen und sich im Becken wohlfühlen.",
    goals: ["Wassergewöhnung", "Vertrauen und Sicherheit im Becken"],
    prereq: "Keine Vorkenntnisse",
    bookingUrl: "https://widgets.yolawo.de/w/0/offers/6a93df26c28f2b6de7e5f01e",
  },
  {
    slug: "seepferdchen",
    level: "02",
    name: "Seepferdchen",
    kicker: "Frühschwimmer",
    age: "Nach Abzeichen-Stand",
    image: "/images/under1.webp",
    alt: "Kind taucht mit Taucherbrille durch klares Wasser",
    text: "Vorbereitung auf das Frühschwimmer-Abzeichen – das erste offizielle Schwimmabzeichen.",
    goals: ["Sprung vom Beckenrand & 25 m schwimmen", "Gegenstand aus schultertiefem Wasser holen", "Kenntnis der Baderegeln"],
    prereq: "Wassergewöhnung",
    bookingUrl: "https://widgets.yolawo.de/w/6a94193077b69f85cea4d0e5",
  },
  {
    slug: "seeraeuber",
    level: "03",
    name: "Seeräuber & Bronze",
    kicker: "Aufbau & Freischwimmer",
    age: "Nach Abzeichen-Stand",
    image: "/images/boy.webp",
    alt: "Junge schwimmt im Wasser und blickt in die Kamera",
    text: "Der Schritt nach dem Seepferdchen: Sicherheit und Ausdauer festigen – bis zum Deutschen Schwimmabzeichen in Bronze.",
    goals: null,
    goalGroups: [
      {
        title: "Seeräuber",
        items: [
          "100 m Brust mit sauberer Technik",
          "5 m Streckentauchen",
          "Gegenstand aus 1–1,5 m Tiefe holen",
        ],
      },
      {
        title: "Bronze",
        items: [
          "200 m in max. 15 Minuten",
          "2 m Tieftauchen mit Gegenstand",
          "Paketsprung vom Startblock oder 1-m-Brett",
          "Kenntnis der Baderegeln",
        ],
      },
    ],
    prereq: "Seepferdchen",
    bookingUrl: "https://widgets.yolawo.de/w/6ae6f8f1d93a84f6240cc5a4",
  },
];

export const ADULT_COURSES = [
  {
    slug: "erwachsene-anfaenger",
    name: "Erwachsene Anfängerkurs",
    kicker: "Schwimmen lernen",
    image: "/images/pool.webp",
    alt: "Ruhiges Hallenbad mit Rettungsring an der Wand",
    text: "Für Erwachsene, die schwimmen lernen möchten – in Ruhe und im eigenen Tempo.",
  },
  {
    slug: "erwachsene-kraul",
    name: "Erwachsene Kraulkurs Anfänger",
    kicker: "Kraultechnik",
    image: "/images/goggles.webp",
    alt: "Schwimmer mit Brille und Kappe im Schwimmbecken",
    text: "Für Erwachsene, die das Kraulschwimmen erlernen möchten.",
  },
];

export const BENEFITS = [
  { icon: "UserRound", title: "Individuelle Aufmerksamkeit", text: "Wir sehen jedes Kind einzeln – mit seinen Stärken und seinem Tempo." },
  { icon: "Hourglass", title: "Im eigenen Tempo", text: "Fortschritt entsteht ohne Druck. Jedes Kind darf sich die Zeit nehmen, die es braucht." },
  { icon: "ShieldCheck", title: "Vertrauen im Wasser", text: "Sicherheit wächst Schritt für Schritt – aus guten Erfahrungen im Becken." },
  { icon: "ListChecks", title: "Klare Lernziele", text: "Strukturierte Stufen von der Wassergewöhnung bis zum Abzeichen in Bronze." },
  { icon: "MessageSquareText", title: "Persönliches Feedback", text: "Eltern sehen Fortschritt und Abzeichen-Stand im Elternbereich." },
  { icon: "Sparkles", title: "Motivierendes Umfeld", text: "Eine ruhige, freundliche Atmosphäre, in der Lernen Freude macht." },
];

export const LOCATION = {
  city: "Dieburg",
  pool: "Sportbad Dieburg",
  street: "Schwimmbadweg 11",
  zip: "64807 Dieburg",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Schwimmbadweg+11,+64807+Dieburg",
};

export const FAQ = [
  {
    q: "Welcher Kurs ist für mein Kind geeignet?",
    a: "Die Kurse bauen aufeinander auf: Froschkurs, Seepferdchen sowie Seeräuber & Bronze. Wo Ihr Kind einsteigt, richtet sich nach seinem aktuellen Abzeichen. Schreiben Sie uns gerne – wir beraten Sie persönlich.",
  },
  {
    q: "Ab welchem Alter kann mein Kind schwimmen lernen?",
    a: "Der Froschkurs ist für Kinder ab 3,5 Jahren. Für alle weiteren Kurse richtet sich die Einstufung nach dem Abzeichen, das Ihr Kind bereits erreicht hat.",
  },
  {
    q: "Wo kann mein Kind in Dieburg schwimmen lernen?",
    a: "Unsere Schwimmkurse finden im Sportbad Dieburg statt: Schwimmbadweg 11, 64807 Dieburg. Die Kurse richten sich an Familien aus Dieburg, Darmstadt und dem Landkreis Darmstadt-Dieburg.",
  },
  {
    q: "Wie bekommt mein Kind das Seepferdchen?",
    a: "Das Seepferdchen ist das Frühschwimmer-Abzeichen. Dazu gehören ein Sprung vom Beckenrand mit 25 m Schwimmen, das Heraufholen eines Gegenstandes aus schultertiefem Wasser und die Kenntnis der Baderegeln. In unserem Seepferdchenkurs bereiten wir Kinder Schritt für Schritt darauf vor.",
  },
  {
    q: "Was ist der Unterschied zwischen Seeräuber und Bronze?",
    a: "Der Seeräuber ist die Stufe nach dem Seepferdchen: 100 m Brustschwimmen mit sauberer Technik, 5 m Streckentauchen und einen Gegenstand aus 1–1,5 m Tiefe heraufholen. Bronze (Freischwimmer) ist das Deutsche Schwimmabzeichen: 200 m in höchstens 15 Minuten, ca. 2 m Tieftauchen mit Heraufholen eines Gegenstandes, ein Paketsprung vom Startblock oder 1-m-Brett und die Kenntnis der Baderegeln. Unser Kurs „Seeräuber & Bronze“ bereitet auf beide Stufen vor.",
  },
  {
    q: "Wie lange dauert ein Schwimmkurs?",
    a: "Ein Kurs besteht aus mehreren Terminen, die in der Regel sonntags stattfinden. Wie viele Termine ein Kurs umfasst und wie lange eine Einheit dauert, sehen Sie beim jeweiligen Kurs in der Kursbuchung.",
  },
  {
    q: "Wie buche ich einen Kurs?",
    a: "Über „Kursplatz sichern“ oder „Jetzt buchen“ gelangen Sie direkt zu unserer Online-Kursbuchung. Dort sehen Sie aktuelle Termine, Preise und freie Plätze.",
  },
  {
    q: "Wie erreiche ich die Schwimmschule?",
    a: "Am einfachsten per E-Mail an info@schwimmschulemanta.de. Bereits angemeldete Familien erreichen uns auch über den Elternbereich.",
  },
];

export const JOURNEY = [
  { slug: "frosch", name: "Frosch", tone: "ice" },
  { slug: "seepferdchen", name: "Seepferdchen", tone: "ice" },
  { slug: "seeraeuber", name: "Seeräuber", tone: "ice" },
  { slug: "bronze", name: "Bronze", tone: "bronze" },
];
